import { SkillStatus } from '../../../../constants/statuses';
var VISIBLE_BARS_COUNT = 14;
var BAR_WIDTH = 24;
var BARS_GAP = 16;
var BAR_HEIGHT = 160;
var BAR_RADIUS = 2;
var BAR_LABEL_LINE_HEIGHT = 16;
var BAR_LABEL_OFFSET = 4;
var BAR_CHART_WIDTH = 944;
var BAR_CHART_HEIGHT = 215;
var ARROW_BUTTON_WIDTH = 40;
var X_TICK_TRANSLATE_X = 10;
var X_TICK_MAX_TEXT_LENGTH = 20;
var Y_AXIS_LABELS_WIDTH = 40;
var BAR_PART_MIN_HEIGHT = 6;
var MAX_GROUPS_PER_PAGE = 4;
var SINGLE_BAR_GROUP_OFFSET = 100;
var BAR_PARTS_ORDER = [
    SkillStatus.NoData,
    SkillStatus.Mastered,
    SkillStatus.Developing,
    SkillStatus.HelpNeeded,
];
export { VISIBLE_BARS_COUNT, BAR_RADIUS, BAR_WIDTH, BAR_HEIGHT, BAR_LABEL_LINE_HEIGHT, BAR_LABEL_OFFSET, BARS_GAP, BAR_CHART_WIDTH, BAR_CHART_HEIGHT, ARROW_BUTTON_WIDTH, BAR_PARTS_ORDER, X_TICK_TRANSLATE_X, X_TICK_MAX_TEXT_LENGTH, Y_AXIS_LABELS_WIDTH, BAR_PART_MIN_HEIGHT, MAX_GROUPS_PER_PAGE, SINGLE_BAR_GROUP_OFFSET, };
